<template>
  <div class="tab-outer-container">
    <div class="tab-items">
      <div v-for="(tab, index) in tabs" :key="index" class="tab-item-wrapper">
        <a-tooltip :title="tab.disabled ? tab.disabledTooltip || '' : ''" placement="top">
          <div
            :class="['tab-item', { 'tab-selected': selectedTab === tab.value, 'tab-disabled': tab.disabled }]"
            :style="selectedTab === tab.value && selectedBackgroundColor ? { background: selectedBackgroundColor } : {}"
            @click="handleTabClick(tab)"
          >
            <div class="tab-content">
              <span class="tab-label">{{ tab.label }}</span>
              <span v-if="tab.discount > 0" :class="['tab-discount', { 'tab-discount-selected': selectedTab === tab.value }]"> SAVE {{ tab.discount }}% </span>
            </div>
          </div>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
    default: () => [],
  },
  selectedTab: {
    type: String,
    required: true,
  },
  selectedBackgroundColor: {
    type: String,
    required: false,
  },
});

const emit = defineEmits(['tab-change']);

const handleTabClick = (tab) => {
  if (tab.disabled) return;
  emit('tab-change', tab.value);
};
</script>

<style scoped>
.tab-outer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--white-opacity-12);
  border-radius: 9999px;
  padding: 8px 8px;
  width: fit-content;
  margin: 0 auto;
}

.tab-items {
  display: flex;
  gap: 0;
}

.tab-item-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tab-item {
  position: relative;
  height: 40px;
  min-width: 87px;
  padding: 8px 16px;
  border-radius: 9999px;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  border: none;
  margin: 0 2px;
  overflow: visible;
  white-space: nowrap;
}

.tab-selected {
  background: linear-gradient(90deg, rgba(179, 67, 203, 0.24) 0%, rgba(112, 149, 235, 0.24) 100%);
  box-shadow: 0 2px 8px rgba(112, 149, 235, 0.08);
}

.tab-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.tab-label {
  font-size: 14px;
  font-weight: 400;
  color: var(--secondary-color);
  white-space: nowrap;
  line-height: 1.2;
}

.tab-selected .tab-label {
  color: var(--text-color);
  font-weight: 600;
}

.tab-discount {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(95deg, #b343cb -37.89%, #7095eb 127.94%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  opacity: 0.8;
  white-space: nowrap;
  line-height: 1;
}

.tab-discount-selected {
  opacity: 1;
}

.tab-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.tab-disabled .tab-label {
  color: var(--secondary-color);
}
</style>
